const actions = {
  SET_STATE: 'sport/competition/SET_STATE',
  REFRESH_ERRORS: 'sport/competition/REFRESH_ERRORS',
  ALL: 'sport/competition/ALL',
  FETCH_ALL: 'sport/competition/FETCH_ALL',
  DETAILS: 'sport/competition/DETAILS',
  ADD: 'sport/competition/ADD',
  EDIT: 'sport/competition/EDIT',
  REMOVE: 'sport/competition/REMOVE'
};

export default actions
